module.exports = __webpack_public_path__ + "img/logo_pleisure_row_color.ebc80886.png";